import { messages } from './messages';
import { componentResultRenderer, endpointResultRenderer } from './result-renderer';
import { CompassScope } from './types';
var mapComponentAggregatorResponseToSearchItem = function mapComponentAggregatorResponseToSearchItem(response) {
  return {
    title: response.title,
    id: response.id,
    meta: response.ownerId,
    url: response.url,
    icon: response.type,
    containerId: '' // no container
  };
};
var mapApiEndpointAggregatorResponseToSearchItem = function mapApiEndpointAggregatorResponseToSearchItem(response) {
  var _response$url$split$p;
  return {
    title: response.title,
    id: response.id,
    url: response.url,
    icon: ((_response$url$split$p = response.url.split('/').pop()) === null || _response$url$split$p === void 0 ? void 0 : _response$url$split$p.split('.')[0]) || '',
    meta: ''
  };
};
export var getSections = function getSections(intl) {
  var sections = [{
    id: CompassScope.Component,
    title: intl.formatMessage(messages.compass_components_section_heading),
    scope: CompassScope.Component,
    showResultCount: true,
    resultRenderer: componentResultRenderer,
    resultMapper: function resultMapper(_ref) {
      var results = _ref.results;
      return results.map(function (value) {
        return mapComponentAggregatorResponseToSearchItem(value);
      });
    }
  }, {
    id: CompassScope.ApiEndpoint,
    title: intl.formatMessage(messages.compass_endpoints_section_heading),
    scope: CompassScope.ApiEndpoint,
    showResultCount: true,
    resultRenderer: endpointResultRenderer,
    resultLimit: 5,
    resultMapper: function resultMapper(_ref2) {
      var results = _ref2.results;
      return results.map(function (value) {
        return mapApiEndpointAggregatorResponseToSearchItem(value);
      });
    }
  }];
  return sections;
};